import axios from '@/utils/request';

let prefix = process.env.VUE_APP_API_PREFIX_2;

// 获取消息列表
const GetMessageList = (params, hideLoading = false) => {
  // return axios.get(prefix + '/message/GetMessageList', {
  //   params
  // });
  return axios.request({
    method: 'get',
    url: prefix + '/message/GetMessageList',
    params,
    headers: {
      hideLoading
    }
  });
};

// 获取消息详情
const GetMessageDetail = params => {
  return axios.get(prefix + '/message/GetMessageDetail', {
    params
  });
};

// 已读消息
const ReadMessage = data => {
  return axios.post(prefix + '/message/ReadMessage', data);
};

// 已读全部消息
const ReadAllMessage = data => {
  return axios.put(prefix + '/message/ReadAllMessage', data);
};

// 获取自己发送消息列表
const GetMySendMessage = params => {
  return axios.get(prefix + '/message/GetMySendMessage', {
    params
  });
};

// 发送消息
const SendMessage = data => {
  return axios.post(prefix + '/message/SendMessage', data);
};

// 删除消息
const DeleteMessage = data => {
  return axios.delete(prefix + '/message/DeleteMessage', data);
};

// 删除全部消息
const DeleteAllMessage = data => {
  return axios.delete(prefix + '/message/DeleteAllMessage', data);
};

export {
  GetMessageList,
  GetMessageDetail,
  ReadMessage,
  ReadAllMessage,
  GetMySendMessage,
  SendMessage,
  DeleteMessage,
  DeleteAllMessage
};
